/**
 * Handle display and validation of AP Verification
 */
const $inject = ["$stateParams"];

class TokenController {
    constructor($stateParams) {
        this.debug = true;

        this.tokenData = window.globalData.tokenData;
    }

}

TokenController.$inject = $inject;

export default TokenController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/features/account/controllers/token.controller.js
 **/